import React, {useState} from "react";
import FormElement
    from "./FormElement";
import useFormMultipleField
    from "../../../hooks/useFormMultipleField";
import useFormSelectHandlers
    from "../../../hooks/useFormSelectHandlers";
import {
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup
} from "@mui/material";
import {useTheme} from "@mui/material/styles";

const FormRadioField = ({
                            template = {},
                            values = {},
                            defaultAnswer = {},
                            onChange,
                            onBlur,
                            disabled = false,
                        }) => {
    const {hiddenLabel} = useTheme();
    const {
        otherFieldValue,
        setOtherFieldValue,
        otherFieldCount,
        setOtherFieldCount,
        options,
        setOptions,
        initialOptions,
        className,
        submissionValue,
        answerObject,
        answers,
        otherProps,
        otherElement,
        choiceType
    } = useFormMultipleField({
        template,
        values,
        defaultAnswer,
        onChange,
        disabled,
        hiddenLabel
    });

    const {
        handleOnSelectChange
    } = useFormSelectHandlers({
        onChange,
        options
    });

    const {
        content,
        name,
    } = template;

    const {
        ignoreIfHidden, // @TODO
        value: possibleValues,
        linkedList, // @TODO
        dataSource, // @TODO
    } = content;

    return (
        <FormElement id={template.id} hiddenLabel={hiddenLabel} label={content.question} className="fz-form-element-multiple" required={otherProps.required}>
            <div className="fz-form-field-multiple-container" id={template.id}>
                <FormControl>
                    {hiddenLabel ? (
                        <FormLabel id={template.id}>{content.question}</FormLabel>) : null}

                    <RadioGroup
                        aria-labelledby={template.id}
                        onBlur={onBlur}
                        onChange={handleOnSelectChange}
                        value={Object.keys(answers).length > 0 ? Object.values(answers)[0] : ''}
                        name={name}>
                        {options.map((option, index) => {
                            const checkedProp = {}

                            checkedProp.checked = !!answers[option.id];

                            return (
                                <FormControlLabel key={index}
                                                  sx={{marginBottom: 0}}
                                                  value={option.item}
                                                  control={
                                                      <Radio/>}
                                                  label={option.item}
                                                  {...otherProps}/>
                            );
                        })}
                    </RadioGroup>
                </FormControl>

            </div>
            {otherElement(disabled)}
        </FormElement>
    )
}

export default FormRadioField;